import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'csl-symbols-count-wrapper',
  standalone: true,
  templateUrl: './symbols-count-wrapper.component.html',
  styleUrl: './symbols-count-wrapper.component.css',
  host: {
    class: 'flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SymbolsCountWrapperComponent {
  @Input({ required: true }) public symbolsCount!: number;
  @Input({ required: true }) public isCountVisible!: boolean | null;
  @Input() public maxLimit?: number;

  public get isGreaterThanMaxLength(): boolean {
    return !!this.maxLimit && this.symbolsCount > this.maxLimit;
  }
}
